import { useNavigate, useParams } from 'react-router-dom'
import { useGetIdsHealthcareservicesHcsIdContactsRpps } from '@toktokdoctech/tokapi-client'
import { ContactProps } from './_props'
import CommonLoaderBackdrop from '../../Common/CommonLoaderBackdrop'
import ErrorDisclaimer from '../../Common/ErrorDisclaimer/ErrorDisclaimer'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import { contactPageErrors } from '../_errors'
import { ContactFormContextProvider } from '../context/ContactFormContext'
import ContactForm from './ContactForm'
import { RouterRouteId } from '../../../routers/_props'
import { defaultValues } from './_utils'

const Contact = ({ mode }: ContactProps) => {
    const navigate = useNavigate()
    const { id: hcsId } = useCurrentHcs()

    const { id } = useParams<RouterRouteId>()

    const { data, isLoading, isError } = useGetIdsHealthcareservicesHcsIdContactsRpps(hcsId, Number(id), {
        query: {
            enabled: mode === 'EDITION',
        },
    })

    if (isLoading) return <CommonLoaderBackdrop open label="Chargement des informations du correspondant..." />
    if (isError)
        return (
            <ErrorDisclaimer
                label={contactPageErrors.unknownError}
                cancelButton={{
                    label: 'Retour à la liste',
                    action: () => navigate('/contacts'),
                }}
                reloadButton={{
                    label: 'Recharger la fiche correspondant',
                }}
            />
        )

    return (
        <ContactFormContextProvider
            initialValues={{
                contactId: id,
                mode,
            }}
        >
            <ContactForm data={data ?? defaultValues} />
        </ContactFormContextProvider>
    )
}

export default Contact
